
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
// import { seeding_modifying_list } from '../lib/modifying';

const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_list: `${FCAPI}/boss/hundun/datacenter/user`,
  teacher_get_list: `${FCAPI}/boss/hundun/setting/teacher`
};

@Component
export default class MissionDetail extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  // @ts-ignore
  @Prop({ default: false }) visible: boolean;
  @Prop({ default: () => [] }) form_list!: any[];
  @Prop({ default: '批量修改' }) title: any;
  @Prop({ default: 0 }) type: any;

  // modifying_info_list: any = this.form_list;
  form: any = this.$form.createForm(this, { name: 'dialog_form' });
  // 确认按钮
  handleOk() {
    this.$emit('handleOk', this.form_list, this.type);
    console.log('handleOk');
  }
  // 取消按钮;
  handleCancel() {
    this.$emit('handleCancel', this.form_list, this.type);
    console.log('handleCancel');
  }
}
